export const METADATA_HEADER_KEY = 'metadata';

export const parseMetadataHeader = (metadataHeader: string) => {
  const personalisationHeaderParams = new URLSearchParams(metadataHeader);

  return Object.fromEntries(personalisationHeaderParams.entries());
};
